const lang = [
  
    {
      label: "Assamese",
      value: "as",
      name: "Assamese",
      supportWebApi: false,
      keyboardLayout:"assamese",
      keyboardLayoutMobile: "assamesemobile",
    },
    {
      label: "Bengali",
      value: "bn",
      name: "বাংলা",
      supportWebApi: false,
      keyboardLayout: "bengali",
      keyboardLayoutMobile: "bengalimobile",
    },
    {
      label: "English",
      value: "en",
      name: "English",
      supportWebApi: false,
      keyboardLayout:"english", 
      keyboardLayoutMobile: "trial",
    },
    {
      label: "Gujarati",
      value: "gu",
      name: "Gujarati",
      supportWebApi: false,
      keyboardLayout:"gujarati" ,
      keyboardLayoutMobile: "gujaratimobile",
    },
    {
      label: "Hindi",
      value: "hi",
      name: "हिन्दी",
      supportWebApi: false,
      keyboardLayout:"hindi",
      keyboardLayoutMobile: "hindimobile",
    },
    {
      label: "Kannada",
      value: "kn",
      name: "ಕನ್ನಡ",
      supportWebApi: false,
      keyboardLayout:"kannada" ,
      keyboardLayoutMobile: "kannadamobile",
    },
    
    {
      label: "Malayalam",
      value: "ml",
      name: "Malayalam",
      supportWebApi: false,
      keyboardLayout:"malayalam" ,
      keyboardLayoutMobile: "malayalammobile",
    },
    {
      label: "Manipuri",
      value: "mni",
      name: "Manipuri",
      supportWebApi: false,
      keyboardLayout:"manipuri", 
      keyboardLayoutMobile: "manipurimobile",
    },
    {
      label: "Marathi",
      value: "mr",
      name: "Marathi",
      supportWebApi: false,
      keyboardLayout:"marathi" ,
      keyboardLayoutMobile: "marathimobile",
    },
   
    {
      label: "Odia",
      value: "or",
      name: "Odia",
      supportWebApi: false,
      keyboardLayout:"odia", 
      keyboardLayoutMobile: "odiamobile",
    },
    {
      label: "Punjabi",
      value: "pa",
      name: "Punjabi",
      supportWebApi: false,
      keyboardLayout:"punjabi", 
      keyboardLayoutMobile: "punjabimobile",
    },
  
    {
      label: "Sindhi",
      value: "sd",
      name: "Sindhi",
      supportWebApi: true,
      keyboardLayout:"sindhi", 
      keyboardLayoutMobile: "arabicmobile",
    },
    {
      label: "Tamil",
      value: "ta",
      name: "தமிழ்",
      supportWebApi: false,
      keyboardLayout:"tamil" ,
      keyboardLayoutMobile: "tamilmobile",
    },
    {
      label: "Telugu",
      value: "te",
      name: "తెలుగు",
      supportWebApi: false,
      keyboardLayout:"telugu", 
      keyboardLayoutMobile: "telugumobile",
    },
    {
      label: "Urdu",
      value: "ur",
      name: "اُردُو",
      supportWebApi: false,
      keyboardLayout:"urdu" ,
      keyboardLayoutMobile: "urdumobile",
    },
    
  
  ];
  
  export const keyboardLayout = {
      assamese: {
        default: [
          "\u0965 \u09e7 \u09e8 \u09e9 \u09ea \u09eb \u09ec \u09ed \u09ee \u09ef \u09e6 \u002d \u09c3 {bksp}",
          "{tab} \u09cc \u09c8 \u09be \u09c0 \u09c2 \u09ac \u09b9 \u0997 \u09a6 \u099c \u09a1 \u09bc",
          "\u09cb \u09c7 \u09cd \u09bf \u09c1 \u09aa \u09f0 \u0995 \u09a4 \u099a \u099f {enter}",
          "{shift} \u0982 \u09ae \u09a8 \u09f1 \u09b2 \u09b8 \u002c \u002e \u09df {shift}",
          ".com @ {space}",
        ],
        shift: [
          "\u0021 \u0040 ( ) \u0983 \u098b {bksp}",
          "{tab} \u0994 \u0990 \u0986 \u0998 \u098a \u09ad \u0999 \u0998 \u09a7 \u099d \u09a2 \u099e",
          "\u0993 \u098f \u0985 \u0987 \u0989 \u09ab  \u0996 \u09a5 \u099b \u099b \u09a0 {enter}",
          "{shift} \u0981 \u09a3 \u09b6 \u09b7 \u0964 \u09af {shift}",
          ".com @ {space}",
        ],
      },
      bengali: {
        default: [
          "` \u200C \u09e7 \u09e8 \u09e9 \u09ea \u09eb \u09ec \u09ed \u09ee \u09ef \u09e6 - = {bksp}",
          "{tab} \u09b8 \u09b9 \u09c7 \u09be \u09bf \u09c1 \u09cb \u0995 \u0997 \u0999 \u09af \u0982 \u09cd",
          "{lock} \u0985 \u0987 \u0989 \u099f \u09a1 \u09a8 \u09a4 \u09a6 \u09aa ; ' {enter}",
          "{shift} \u09ac \u09ae \u099a \u099c \u09b0 \u09b2 \u09b6 , . / {shift}",
          ".com @ {space}",
        ],
        shift: [
          "~ \u200d ! \u09cd\u09af \u09cd\u09b0 \u09f3 \u0025 \u0964 \u09b0\u09cd \u00d7 ( ) \u0981 + {bksp}",
          "{tab} \u0993 \u0994 \u09c8 \u09c3 \u09c0 \u09c2 \u09cc \u0996 \u0998 \u098b \u09df \u09ce \u0983",
          '{lock} \u0986 \u0988 \u098a \u09a0 \u09a2 \u09a3 \u09a5 \u09a7 \u09ab : " {enter}',
          "{shift} \u09ad \u099e \u099b \u099d \u09dc \u09dd \u09b7 \u098f \u0990 ? {shift}",
          ".com @ {space}",
        ],
      },
      hindi: {
        default: [
          "` \u090D \u0945 \u094D\u0930 \u0930\u094D \u091C\u094D\u091E \u0924\u094D\u0930 \u0915\u094D\u0937 \u0936\u094D\u0930 \u096F \u0966 - \u0943 {bksp}",
          "{tab} \u094C \u0948 \u093E \u0940 \u0942 \u092C \u0939 \u0917 \u0926 \u091C \u0921 \u093C \u0949 \\",
          "{lock} \u094B \u0947 \u094D \u093F \u0941 \u092A \u0930 \u0915 \u0924 \u091A \u091F {enter}",
          "{shift} \u0902 \u092E \u0928 \u0935 \u0932 \u0938 , . \u092F {shift}",
          ".com @ {space}",
        ],
        shift: [
          "~ \u0967 \u0968 \u0969 \u096A \u096B \u096C \u096D \u096E \u096F \u0966 \u0903 \u090B {bksp}",
          "{tab} \u0914 \u0910 \u0906 \u0908 \u090A \u092D \u0919 \u0918 \u0927 \u091D \u0922 \u091E \u0911",
          "{lock} \u0913 \u090F \u0905 \u0907 \u0909 \u092B \u0931 \u0916 \u0925 \u091B \u0920 {enter}",
          '{shift} "" \u0901 \u0923 \u0928 \u0935 \u0933 \u0936 \u0937 \u0964 \u095F {shift}',
          ".com @ {space}",
        ],
      },
      kannada: {
        default: [
          "\u0cca 1 2 3 4 5 6 7 8 9 0 - \u0cc3 {bksp}",
          "{tab} \u0ccc \u0cc8 \u0cbe \u0cc0 \u0cc2 \u0cac \u0cb9 \u0c97 \u0ca6 \u0c9c \u0ca1",
          "\u0ccb \u0cc7 \u0ccd \u0cbf \u0cc1 \u0caa \u0cb0 \u0c95 \u0ca4 \u0c9a \u0c9f {enter}",
          "{shift} \u0cc6 \u0c82 \u0cae \u0ca8 \u0cb5 \u0cb2 \u0cb8 , . / {shift}",
          ".com @ {space}",
        ],
        shift: [
          "\u0c92 \u0ccd\u0cb0 \u0cb0\u0ccd \u0c9c\u0ccd\u0c9e \u0ca4\u0ccd\u0cb0 \u0c95\u0ccd\u0cb7 \u0cb6\u0ccd\u0cb0 ( ) \u0c83 \u0c8b {bksp}",
          "{tab} \u0c94 \u0c90 \u0c86 \u0c88 \u0c8a \u0cad \u0c99 \u0c98 \u0ca7 \u0c9d \u0ca2 \u0c9e",
          "\u0c93 \u0c8f \u0c85 \u0c87 \u0c89 \u0cab \u0cb1 \u0c96 \u0ca5 \u0c9b \u0ca0 {enter}",
          "{shift} \u0c8e \u0ca3 \u0cb3 \u0cb6 \u0cb7 | / {shift}",
          ".com @ {space}",
        ],
      },
      marathi: {
        default: [
         "~ \u0AE7 \u0AE8 \u0AE9 \u0AEA \u0AEB \u0AEC \u0AED \u0AEE \u0AEF \u0AE6 \u0A83 \u0A8B {bksp}",
         "{tab} \u0A94 \u0A90 \u0A86 \u0A88 \u0A8A \u0AAD \u0A99 \u0A98 \u0AA7 \u0A9D \u0AA2 \u0A9E \u0A91",
         "{lock} \u0A93 \u0A8F \u0A85 \u0A87 \u0A89 \u0AAB \u0A96 \u0AA5 \u0A9B \u0AA0 {enter}",
         "{shift} \u0A81 \u0AA3 \u0AB3 \u0AB6 \u0AB7 \u0964 {shift}",
         ".com @ {space}",
        ],
        shift: [
         "` \u0A8D \u0AC5 \u0AC7 \u0AEA \u0AEB \u0AEC \u0AED \u0AEE \u0AEF \u0AE6 \u0A83 \u0A8B {bksp}",
         "{tab} \u0ACC \u0AC8 \u0ABE \u0AC0 \u0AC2 \u0AAC \u0AB9 \u0A97 \u0AA6 \u0A9C \u0ABD \u0ABC \\",
         "{lock} \u0ACB \u0AC7 \u0ACD \u0ABF \u0AC1 \u0AAA \u0AB0 \u0A95 \u0AA4 \u0A9A \u0A9F {enter}",
         "{shift} \u0A82 \u0AAE \u0AA8 \u0AB5 \u0AB2 \u0AB8 , . \u0AAF {shift}",
         ".com @ {space}",
        ],
      },
      malayalam: {
        default: [
          "\u0D12 \u0D67 \u0D68 \u0D69 \u0D6A \u0D6B \u0D6C \u0D6D \u0D6E \u0D6F \u0D66 - \u0D0B {bksp}",
          "{tab} \u0D14 \u0D10 \u0D06 \u0D08 \u0D0A \u0D2D \u0D19 \u0D18 \u0D27 \u0D1D \u0D22 \u0D1E \\",
          "{lock} \u0D13 \u0D0F \u0D05 \u0D07 \u0D09 \u0D2B \u0D31 \u0D16 \u0D25 \u0D1B \u0D20 {enter}",
          "{shift} \u0D0E \u0D03 \u0D23 \u0D34 \u0D33 \u0D36 \u0D37 . \u0D2F {shift}",
          ".com @ {space}",
        ],
        shift: [
          "\u0D4A ! @ # $ % ^ & * ) ( _ \u0D43 {bksp}",
          "{tab} \u0D4C \u0D48 \u0D3E \u0D40 \u0D42 \u0D2C \u0D39 \u0D17 \u0D26 \u0D1C \u0D21 \u0D4E \\",
          "{lock} \u0D4B \u0D47 \u0D4D \u0D3F \u0D41 \u0D2A \u0D30 \u0D15 \u0D24 \u0D1A \u0D1F {enter}",
          "{shift} \u0D46 \u0D02 \u0D2E \u0D28 \u0D35 \u0D32 \u0D38 . \u0D2F {shift}",
          ".com @ {space}",
        ],
      },
      manipuri: {
        default: [
          "\uABC0 \uABC1 \uABC2 \uABC3 \uABC4 \uABC5 \uABC6 \uABC7 \uABC8 \uABC9 {bksp}",
          "{tab} \uABCA \uABCB \uABCC \uABCD \uABCE \uABCF \uABD0 \uABD1 \uABD2 \uABD3 \\",
          "{lock} \uABD4 \uABD5 \uABD6 \uABD7 \uABD8 \uABD9 \uABDA \uABDB \uABDC {enter}",
          "{shift} \uABE4 \uABDD \uABDE \uABDF \uABE0 \uABE1 \uABE2 \uABEB {shift}",
          ".com @ {space}",
        ],
        shift: [
          "\uABD1 \uABE5 \uABCF \uABCE \uABE9 \uABE7 \uABEA \uABC0 \uABC8 \uABD2 {bksp}",
          "{tab} \uABD8 \uABC9 \uABC6 \uABD6 \uABD3 \uABC7 \uABCA \uABD7 \uABD9 \uABC5 \\",
          "{lock} \uABC4 \uABD0 \uABD5 \uABDA \uABC3 \uABCC \uABD4 \uABC2 \uABCB {enter}",
          "{shift} \uABC1 \uABCD \uABDB \uABE0 \uABDF \uABD0 \uABDC \uABE1 {shift}",
          ".com @ {space}",
        ],
      },
      gujarati: {
        default: [
         "~ \u0AE7 \u0AE8 \u0AE9 \u0AEA \u0AEB \u0AEC \u0AED \u0AEE \u0AEF \u0AE6 \u0A83 \u0A8B {bksp}",
         "{tab} \u0A94 \u0A90 \u0A86 \u0A88 \u0A8A \u0AAD \u0A99 \u0A98 \u0AA7 \u0A9D \u0AA2 \u0A9E \u0A91",
         "{lock} \u0A93 \u0A8F \u0A85 \u0A87 \u0A89 \u0AAB \u0A92 \u0A96 \u0AA5 \u0A9B \u0AA0 {enter}",
         "{shift} \u0A80 \u0A81 \u0AA3 \u0AA9 \u0AB1 \u0AB3 \u0AB6 \u0AB7 \u0964 \u0ABB {shift}",
         ".com @ {space}",
        ],
        shift: [
         "` \u0A8D \u0AC5 \u0AC7 \u0AEA \u0AEB \u0AEC \u0AED \u0AEE \u0AEF \u0AE6 \u0A83 \u0A8B {bksp}",
         "{tab} \u0ACC \u0AC8 \u0ABE \u0AC0 \u0AC2 \u0AAC \u0AB9 \u0A97 \u0AA6 \u0A9C \u0ABD \u0ABC \\",
         "{lock} \u0ACB \u0AC7 \u0ACD \u0ABF \u0AC1 \u0AAA \u0AB0 \u0A95 \u0AA4 \u0A9A \u0A9F {enter}",
         "{shift} \u0A80 \u0A82 \u0AAE \u0AA8 \u0AB5 \u0AB2 \u0AB8 , . \u0AAF {shift}",
         ".com @ {space}",
        ],
      },
      odia: {
        default: [
          "\u0B66 \u0B67 \u0B68 \u0B69 \u0B6A \u0B6B \u0B6C \u0B6D \u0B6E \u0B6F \u0B0B \u0B43 {bksp}",
          "{tab} \u0B4C \u0B48 \u0B3E \u0B40 \u0B42  \u0B2C \u0B39 \u0B17 \u0B26 \u0B1C \u0B21 \u0B3C",
          "{lock} \u0B4B \u0B47 \u0B4D \u0B3F \u0B41 \u0B2A \u0B30 \u0B15 \u0B24 \u0B1A \u0B1F {enter}",
          "{shift} \u0B5F \u0B02 \u0B2E \u0B28 \u0B71 \u0B32 \u0B38 \u002C \u002E \u0B5F {shift}",
          ".com @ {space}",
        ],
        shift: [
          "\u0B4D\u0B30 \u0B30\u0B4D \u0B1C\u0B4D\u0B1E \u0B24\u0B4D\u0B30 \u0B15\u0B4D\u0B37 \u0B36\u0B4D\u0B30 \u0028 \u0029 \u0B03 \u0B60 \u0B44 {bksp}",
          "{tab} \u0B14 \u0B10 \u0B06 \u0B08 \u0B0A \u0B2D \u0B19 \u0B18 \u0B27 \u0B1D \u0B22 \u0B5C \u0B1E",
          "{lock} \u0B13 \u0B0F \u0B05 \u0B62 \u0B07 \u0B09 \u0B2B \u0B16 \u0B25 \u0B1B \u0B20 {enter}",
          "{shift} \u0B71 \u0B01 \u0B70 \u0B23 \u0B35 \u0B33 \u0B36 \u0B37 \u0964 \u0B2F {shift}",
          ".com @ {space}",
        ],
      },
      punjabi: {
        default: [
          "1 2 3 4 5 6 7 8 9 0 - {bksp}",
          "{tab} \u0A4C \u0A48 \u0A3E \u0A40 \u0A42 \u0A2C \u0A39 \u0A17 \u0A26 \u0A1C \u0A21 \u0A3C",
          "{lock} \u0A4B \u0A47 \u0A4D \u0A3F \u0A41 \u0A2A \u0A30 \u0A15 \u0A24 \u0A1A \u0A1F {enter}",
          "{shift} \u0A70 \u0A2E \u0A28 \u0A35 \u0A32 \u0A38 , . \u0A2F {shift}",
          ".com @ {space}"
        ],
        shift: [
          "\u0A4D \u0A39 \u0A4D \u0A35 \u0A4D \u0A2F \u0A4D \u0A30 \u0A71 ( ) {bksp}",
          "{tab} \u0A14 \u0A10 \u0A06 \u0A08 \u0A0A \u0A2D \u0A19 \u0A18 \u0A27 \u0A1D \u0A22 \u0A1E",
          "{lock} \u0A13 \u0A0F \u0A05 \u0A07 \u0A09 \u0A2B \u0A5C \u0A16 \u0A25 \u0A1B \u0A20 {enter}",
          "{shift} \u0A02 \u0A23 \u0A72 \u0A33 \u0A36 \u0964 {shift}",
          ".com @ {space}"
        ]
      },
      
      tamil: {
        default: [
         "` \u0BE7 \u0BE8 \u0BE9 \u0BEA \u0BEB \u0BEC \u0BED \u0BEE \u0BEF \u0BE6 - = {bksp}",
         "{tab} \u0BCC \u0BC8 \u0BBE \u0BC0 \u0BC0 \u0BAA \u0BB9 \u0B95 \u0BA4 \u0B9C \u0B9F \u0B9E \\",
         "{lock} \u0BCB \u0BC7 \u0BCD \u0BBF \u0BBF \u0BAA \u0BB0 \u0BA4 \u0B9C \u0B9A \u0B9F {enter}",
         "{shift} \u0BC6 \u0BC6 \u0BAE \u0BA8 \u0BB5 \u0BB2 \u0BB8 , . \u0BAF {shift}",
         ".com @ {space}",
        ],
        shift: [
         "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
         "{tab} \u0B94 \u0B90 \u0B86 \u0B88 \u0B8A \u0BAA \u0B99 \u0BE7 \u0B9A \u0B9F \u0B9F } |",
         '{lock} \u0B92 \u0B8F \u0B85 \u0B87 \u0B89 \u0BAA \u0BB1 \u0B95 \u0BA4 \u0B9A \u0B9F {enter}',
         "{shift} \u0B8E \u0B8E \u0BA3 \u0BA9 \u0BB4 \u0BB3 < > ? {shift}",
         ".com @ {space}",
        ],
      },
      telugu: {
      default: [
        "\u0C4A 1 2 3 4 5 6 7 8 9 0 - \u0C43 {bksp}",
        "{tab} \u0C4C \u0C48 \u0C3E \u0C40 \u0C42 \u0C2C \u0C39 \u0C17 \u0C26",
        "{lock} \u0C4B \u0C47 \u0C4D \u0C3F \u0C41 \u0C2A \u0C30 \u0C15 \u0C24 \u0C1A \u0C1F {enter}",
        "{shift} \u0C46 \u0C02 \u0C2E \u0C28 \u0C35 \u0C32 \u0C38 , . \u0C2F {shift}",
        ".com @ {space}"
      ],
      shift: [
        "\u0C12 \u0C4D\u0C30 \u0C1C\u0C4D\u0C1E \u0C24\u0C4D\u0C30 \u0C15\u0C4D\u0C37 \u0C36\u0C4D\u0C30 ( ) \u0C03 \u0C0B {bksp}",
        "{tab} \u0C14 \u0C10 \u0C06 \u0C08 \u0C0A \u0C2D \u0C19 \u0C18 \u0C27 \u0C1D \u0C22 \u0C1E",
        "{lock} \u0C13 \u0C0F \u0C05 \u0C07 \u0C09 \u0C2B \u0C31 \u0C16 \u0C25 \u0C1B \u0C20 {enter}",
        "{shift} \u0C0E \u0C01 \u0C23 \u0C28 \u0C33 \u0C36 \u0C37 {shift}",
        ".com @ {space}"
      ]
     },
     urdu: {
      default: [
        "` \u0661 \u0662 \u0663 \u0664 \u0665 \u0666 \u0667 \u0668 \u0669 \u0660 - = {bksp}",
        "{tab} \u0642 \u0648 \u0639 \u0631 \u062A \u06D2 \u0621 \u0649 \u06C1 \u067E [ ]",
        "{lock} \u0627 \u0633 \u062F \u0641 \u06AF \u06BE \u062C \u06A9 \u0644 \u061B \u060C {enter}",
        "{shift} \u0632 \u0634 \u0686 \u0637 \u0628 \u0646 \u0645 \u06E4 , . / {shift}",
        ".com @ {space}",
      ],
      shift: [
        "~ ! @ # $ \u066A ^ & * ( ) _ + {bksp}",
        "{tab} \uFE70 \uFE77 \uFE79 \u0691 \u0679 \uFE7A \uFEFB \uFE8B \u0629 | { }",
        "{lock} \u0622 \u0635 \u0688 \u060D \u063A \u062D \u0636 \u062E \u06D4 \u0703 \u05f4 {enter}",
        "{shift} \u0630 \u0698 \u062B \u0638 \u06BA \u066b \u0640 < > \u061F {shift}",
        ".com @ {space}",
      ],
    },
    arabic: {
      default: [
        "\u0630 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
        "{tab} \u0636 \u0635 \u062B \u0642 \u0641 \u063A \u0639 \u0647 \u062E \u062D \u062C \u062F \\",
        "{lock} \u0634 \u0633 \u064A \u0628 \u0644 \u0627 \u062A \u0646 \u0645 \u0643 \u0637 {enter}",
        "{shift} \u0626 \u0621 \u0624 \u0631 \u0644\u0627 \u0649 \u0629 \u0648 \u0632 \u0638 {shift}",
        ".com @ {space}",
      ],
      shift: [
        "\u0651 ! @ # $ % ^ & * ) ( _ + {bksp}",
        "{tab} \u064E \u064B \u064F \u064C \u0644\u0625 \u0625 \u2018 \u00F7 \u00D7 \u061B < > |",
        '{lock} \u0650 \u064D ] [ \u0644\u0623 \u0623 \u0640 \u060C / : " {enter}',
        "{shift} ~ \u0652 } { \u0644\u0622 \u0622 \u2019 , . \u061F {shift}",
        ".com @ {space}",
      ],
    },
    trial: {
      default: [
       "q w e r t y u i o p",
       "a s d f g h j k l",
       "{shift} z x c v b n m {backspace}",
       "{numbers} {space} {ent}"
      ],
      shift: [
       "Q W E R T Y U I o P",
       "A S D F G H J K L",
       "{shift} Z X C V B N M {backspace}",
       "{numbers} {space} {ent}"
      ],
      numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
     },
     assamesemobile: {
      default: [
        "\u09cc \u09c8 \u09be \u09c0 \u09c2 \u09ac \u09b9 \u0997 \u09a6 \u099c \u09a1 \u09bc",
        "\u09cb \u09c7 \u09cd \u09bf \u09c1 \u09aa \u09f0 \u0995 \u09a4 \u099a \u099f",
        "{shift} \u0982 \u09ae \u09a8 \u09f1 \u09b2 \u09b8 \u002c \u002e \u09df {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0021 \u0040 ( ) \u0983 \u098b",
        "\u0994 \u0990 \u0986 \u0998 \u098a \u09ad \u0999 \u0998 \u09a7 \u099d \u09a2 \u099e",
        "\u0993 \u098f \u0985 \u0987 \u0989 \u09ab  \u0996 \u09a5 \u099b \u099b \u09a0",
        "{shift} \u0981 \u09a3 \u09b6 \u09b7 \u0964 \u09af {backspace}",
        "{numbers} {space} {ent}"
      ],
      numbers: ["\u09e7 \u09e8 \u09e9", "\u09ea \u09eb \u09ec", "\u09ed \u09ee \u09ef", "{abc} \u09e6 {backspace}"],
    },
    bengalimobile: {
      default: [
        
        "\u09b8 \u09b9 \u09c7 \u09be \u09bf \u09c1 \u09cb \u0995 \u0997 \u0999 \u09af \u0982 \u09cd",
        "\u0985 \u0987 \u0989 \u099f \u09a1 \u09a8 \u09a4 \u09a6 \u09aa",
        "{shift} \u09ac \u09ae \u099a \u099c \u09b0 \u09b2 \u09b6 {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0993 \u0994 \u09c8 \u09c3 \u09c0 \u09c2 \u09cc \u0996 \u0998 \u098b \u09df \u09ce \u0983",
        '\u0986 \u0988 \u098a \u09a0 \u09a2 \u09a3 \u09a5 \u09a7 \u09ab',
        "{shift} \u09ad \u099e \u099b \u099d \u09dc \u09dd \u09b7 \u098f \u0990 {backspace}",
        "{numbers} {space} {ent}"
      ],
      numbers: ["\u09e7 \u09e8 \u09e9", "\u09ea \u09eb \u09ec", "\u09ed \u09ee \u09ef", "{abc} \u09e6 {backspace}"],
    },
    hindimobile: {
      default: [
        "\u090D \u0945 \u094D\u0930 \u0930\u094D \u091C\u094D\u091E \u0924\u094D\u0930 \u0915\u094D\u0937 \u0936\u094D\u0930 \u096F \u0966 - \u0943",
        "\u094C \u0948 \u093E \u0940 \u0942 \u092C \u0939 \u0917 \u0926 \u091C \u0921 \u093C \u0949",
        "\u094B \u0947 \u094D \u093F \u0941 \u092A \u0930 \u0915 \u0924 \u091A \u091F",
        "{shift} \u0902 \u092E \u0928 \u0935 \u0932 \u0938\u092F {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0914 \u0910 \u0906 \u0908 \u090A \u092D \u0919 \u0918 \u0927 \u091D \u0922 \u091E \u0911",
        "\u0913 \u090F \u0905 \u0907 \u0909 \u092B \u0931 \u0916 \u0925 \u091B \u0920",
        '{shift} "" \u0901 \u0923 \u0928 \u0935 \u0933 \u0936 \u0937 \u0964 \u095F {backspace}',
        "{numbers} {space} {ent}"
      ],
      numbers: ["\u0967 \u0968 \u0969", "\u096A \u096B \u096C", "\u096D \u096E \u096F", "{abc} \u0966 {backspace}"],
    },
    kannadamobile: {
      default: [
        "\u0ccc \u0cc8 \u0cbe \u0cc0 \u0cc2 \u0cac \u0cb9 \u0c97 \u0ca6 \u0c9c \u0ca1",
        "\u0ccb \u0cc7 \u0ccd \u0cbf \u0cc1 \u0caa \u0cb0 \u0c95 \u0ca4 \u0c9a \u0c9f",
        "{shift} \u0cc6 \u0c82 \u0cae \u0ca8 \u0cb5 \u0cb2 \u0cb8 {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0c92 \u0ccd\u0cb0 \u0cb0\u0ccd \u0c9c\u0ccd\u0c9e \u0ca4\u0ccd\u0cb0 \u0c95\u0ccd\u0cb7 \u0cb6\u0ccd\u0cb0 \u0c83 \u0c8b",
        "\u0c94 \u0c90 \u0c86 \u0c88 \u0c8a \u0cad \u0c99 \u0c98 \u0ca7 \u0c9d \u0ca2 \u0c9e",
        "\u0c93 \u0c8f \u0c85 \u0c87 \u0c89 \u0cab \u0cb1 \u0c96 \u0ca5 \u0c9b \u0ca0 {enter}",
        "{shift} \u0c8e \u0ca3 \u0cb3 \u0cb6 \u0cb7 {backspace}",
        "{numbers} {space} {ent}"
      ],
      numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
    },
    marathimobile: {
      default: [
       "\u0A94 \u0A90 \u0A86 \u0A88 \u0A8A \u0AAD \u0A99 \u0A98 \u0AA7 \u0A9D \u0AA2 \u0A9E \u0A91",
       "\u0A93 \u0A8F \u0A85 \u0A87 \u0A89 \u0AAB \u0A92 \u0A96 \u0AA5 \u0A9B \u0AA0",
       "{shift} \u0A81 \u0AA3 \u0AB3 \u0AB6 \u0AB7 \u0964 {backspace}",
       "{numbers} {space} {ent}"
      ],
      shift: [
       "\u0A8D \u0AC5 \u0AC7 \u0AEA \u0AEB \u0AEC \u0AED \u0AEE \u0AEF \u0AE6 \u0A83 \u0A8B",
       "\u0ACC \u0AC8 \u0ABE \u0AC0 \u0AC2 \u0AAC \u0AB9 \u0A97 \u0AA6 \u0A9C \u0ABD \u0ABC",
       "\u0ACB \u0AC7 \u0ACD \u0ABF \u0AC1 \u0AAA \u0AB0 \u0A95 \u0AA4 \u0A9A \u0A9F",
       "{shift} \u0A82 \u0AAE \u0AA8 \u0AB5 \u0AB2 \u0AB8 \u0AAF {backspace}",
       "{numbers} {space} {ent}"
      ],
      numbers: ["\u0AE7 \u0AE8 \u0AE9", "\u0AEA \u0AEB \u0AEC", "\u0AED \u0AEE \u0AEF", "{abc} \u0AE6 {backspace}"],
    },
    manipurimobile: {
      default: [
        "\uABC0 \uABC1 \uABC2 \uABC3 \uABC4 \uABC5 \uABC6 \uABC7 \uABC8 \uABC9",
        "\uABCA \uABCB \uABCC \uABCD \uABCE \uABCF \uABD0 \uABD1 \uABD2 \uABD3",
        "\uABD4 \uABD5 \uABD6 \uABD7 \uABD8 \uABD9 \uABDA \uABDB \uABDC",
        "{shift} \uABE4 \uABDD \uABDE \uABDF \uABE0 \uABE1 \uABE2 \uABEB {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\uABD1 \uABE5 \uABCF \uABCE \uABE9 \uABE7 \uABEA \uABC0 \uABC8 \uABD2",
        "\uABD8 \uABC9 \uABC6 \uABD6 \uABD3 \uABC7 \uABCA \uABD7 \uABD9 \uABC5",
        "\uABC4 \uABD0 \uABD5 \uABDA \uABC3 \uABCC \uABD4 \uABC2 \uABCB",
        "{shift} \uABC1 \uABCDd \uABDB \uABE0 \uABDF \uABD0 \uABDC \uABE1 {backspace}",
        "{numbers} {space} {ent}"
      ],
      numbers: ["\uabf1 \uabf2 \uabf3", "\uabf4 \uabf5 \uabf6", "\uabf7 \uabf8 \uabf9", "{abc} \uabf0 {backspace}"],
  
    },
    malayalammobile: {
      default: [
        "\u0D14 \u0D10 \u0D06 \u0D08 \u0D0A \u0D2D \u0D19 \u0D18 \u0D27 \u0D1D \u0D22 \u0D1E",
        "\u0D13 \u0D0F \u0D05 \u0D07 \u0D09 \u0D2B \u0D31 \u0D16 \u0D25 \u0D1B \u0D20",
        "{shift} \u0D0E \u0D03 \u0D23 \u0D34 \u0D33 \u0D36 \u0D37 . \u0D2F {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0D4C \u0D48 \u0D3E \u0D40 \u0D42 \u0D2C \u0D39 \u0D17 \u0D26 \u0D1C \u0D21 \u0D4E",
        "\u0D4B \u0D47 \u0D4D \u0D3F \u0D41 \u0D2A \u0D30 \u0D15 \u0D24 \u0D1A \u0D1F",
        "{shift} \u0D46 \u0D02 \u0D2E \u0D28 \u0D35 \u0D32 \u0D38 . \u0D2F {backspace}",
        "{numbers} {space} {ent}"
      ],
      numbers: ["\u0D67 \u0D68 \u0D69", "\u0D6A \u0D6B \u0D6C", "\u0D6D \u0D6E \u0D6F", "{abc} \u0D66 {backspace}"],
    },
    gujaratimobile: {
      default: [
       "\u0A94 \u0A90 \u0A86 \u0A88 \u0A8A \u0AAD \u0A99 \u0A98 \u0AA7 \u0A9D \u0AA2 \u0A9E \u0A91",
       "\u0A93 \u0A8F \u0A85 \u0A87 \u0A89 \u0AAB \u0A92 \u0A96 \u0AA5 \u0A9B \u0AA0",
       "{shift} \u0A80 \u0A81 \u0AA3 \u0AA9 \u0AB1 \u0AB3 \u0AB6 \u0AB7 \u0964 \u0ABB {backspace}",
       "{numbers} {space} {ent}"
      ],
      shift: [
       "\u0A8D \u0AC5 \u0AC7 \u0AEA \u0AEB \u0AEC \u0AED \u0AEE \u0AEF \u0AE6 \u0A83 \u0A8B",
       "\u0ACC \u0AC8 \u0ABE \u0AC0 \u0AC2 \u0AAC \u0AB9 \u0A97 \u0AA6 \u0A9C \u0ABD \u0ABC",
       "\u0ACB \u0AC7 \u0ACD \u0ABF \u0AC1 \u0AAA \u0AB0 \u0A95 \u0AA4 \u0A9A \u0A9F ",
       "{shift} \u0A80 \u0A82 \u0AAE \u0AA8 \u0AB5 \u0AB2 \u0AB8 \u0AAF {backspace}",
       "{numbers} {space} {ent}"
      ],
      numbers: ["\u0AE7 \u0AE8 \u0AE9", "\u0AEA \u0AEB \u0AEC", "\u0AED \u0AEE \u0AEF", "{abc} \u0AE6 {backspace}"],
    },
    odiamobile: {
      default: [
        "\u0B4C \u0B48 \u0B3E \u0B40 \u0B42 \u0B2C \u0B39 \u0B17 \u0B26 \u0B1C \u0B21 \u0B3C",
        "\u0B4B \u0B47 \u0B4D \u0B3F \u0B41 \u0B2A \u0B30 \u0B15 \u0B24 \u0B1A \u0B1F"             ,                                      
        "{shift} \u0B5F \u0B02 \u0B2E \u0B28 \u0B71 \u0B32 \u0B38 \u002C \u002E \u0B5F {backspace}",
        "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0B4D\u0B30 \u0B30\u0B4D \u0B1C\u0B4D\u0B1E \u0B24\u0B4D\u0B30 \u0B15\u0B4D\u0B37 \u0B36\u0B4D\u0B30 \u0028 \u0029  \u0B03 \u0B60 \u0B44",
        "\u0B14 \u0B10 \u0B06 \u0B08 \u0B0A \u0B2D \u0B19 \u0B18 \u0B27 \u0B1D \u0B22 \u0B5C \u0B1E",
        "\u0B13 \u0B0F \u0B05 \u0B62 \u0B07 \u0B09 \u0B2B \u0B16 \u0B25 \u0B1B \u0B20",
        "{shift} \u0B71 \u0B01 \u0B70 \u0B23 \u0B35 \u0B33 \u0B36 \u0B37 \u0964 \u0B2F {backspace}",
        "{numbers} {space} {ent}"
      ],
      numbers: ["\u0B67 \u0B68 \u0B69", "\u0B6A \u0B6B \u0B6C", "\u0B6D \u0B6E \u0B6F", "{abc} \u0B66 {backspace}"],
    },
    punjabimobile: {
      default: [
        "\u0A4C \u0A48 \u0A3E \u0A40 \u0A42 \u0A2C \u0A39 \u0A17 \u0A26 \u0A1C \u0A21 \u0A3C",
        "\u0A4B \u0A47 \u0A4D \u0A3F \u0A41 \u0A2A \u0A30 \u0A15 \u0A24 \u0A1A \u0A1F",
        "{shift} \u0A70 \u0A2E \u0A28 \u0A35 \u0A32 \u0A38 , . \u0A2F {backspace}",
          "{numbers} {space} {ent}"
      ],
      shift: [
        "\u0A4D\u0A39 \u0A4D\u0A35 \u0A4D\u0A2F \u0A4D\u0A30 \u0A71 ( )",
        "\u0A14 \u0A10 \u0A06 \u0A08 \u0A0A \u0A2D \u0A19 \u0A18 \u0A27 \u0A1D \u0A22 \u0A1E",
        "\u0A13 \u0A0F \u0A05 \u0A07 \u0A09 \u0A2B \u0A5C \u0A16 \u0A25 \u0A1B \u0A20",
        "{shift} \u0A02 \u0A23 \u0A72 \u0A33 \u0A36 \u0964 {backspace}",
          "{numbers} {space} {ent}"
      ],
      numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
      
    },
    
    tamilmobile: {
      default: [
       "\u0BCC \u0BC8 \u0BBE \u0BC0 \u0BC0 \u0BAA \u0BB9 \u0B95 \u0BA4 \u0B9C \u0B9F \u0B9E \\",
       "\u0BCB \u0BC7 \u0BCD \u0BBF \u0BBF \u0BAA \u0BB0 \u0BA4 \u0B9C \u0B9A \u0B9F",
       "{shift} \u0BC6 \u0BC6 \u0BAE \u0BA8 \u0BB5 \u0BB2 \u0BB8 \u0BAF {backspace}",
       "{numbers} {space} {ent}"
      ],
      shift: [
       "\u0B94 \u0B90 \u0B86 \u0B88 \u0B8A \u0BAA \u0B99 \u0BE7 \u0B9A \u0B9F \u0B9F",
       '\u0B92 \u0B8F \u0B85 \u0B87 \u0B89 \u0BAA \u0BB1 \u0B95 \u0BA4 \u0B9A \u0B9F',
       "{shift} \u0B8E \u0B8E \u0BA3 \u0BA9 \u0BB4 \u0BB3 {backspace}",
       "{numbers} {space} {ent}"
      ],
      
      numbers: ["\u0BE7 \u0BE8 \u0BE9", "\u0BEA \u0BEB \u0BEC", "\u0BED \u0BEE \u0BEF", "{abc} \u0BE6 {backspace}"],
    },
    telugumobile: {
    default: [
      "\u0C4C \u0C48 \u0C3E \u0C40 \u0C42 \u0C2C \u0C39 \u0C17 \u0C26 \u0C1C \u0C21",
      "\u0C4B \u0C47 \u0C4D \u0C3F \u0C41 \u0C2A \u0C30 \u0C15 \u0C24 \u0C1A \u0C1F",
      "{shift} \u0C46 \u0C02 \u0C2E \u0C28 \u0C35 \u0C32 \u0C38 \u0C2F {backspace}",
        "{numbers} {space} {ent}"
    ],
    shift: [
      "\u0C12 \u0C4D\u0C30 \u0C1C\u0C4D\u0C1E \u0C24\u0C4D\u0C30 \u0C15\u0C4D\u0C37 \u0C36\u0C4D\u0C30 \u0C03 \u0C0B",
      "\u0C14 \u0C10 \u0C06 \u0C08 \u0C0A \u0C2D \u0C19 \u0C18 \u0C27 \u0C1D \u0C22 \u0C1E",
      "\u0C13 \u0C0F \u0C05 \u0C07 \u0C09 \u0C2B \u0C31 \u0C16 \u0C25 \u0C1B \u0C20 {backspace}",
      "{shift} \u0C0E \u0C01 \u0C23 \u0C28 \u0C33 \u0C36 \u0C37",
        "{numbers} {space} {ent}"
    ],
    numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
   },
   urdumobile: {
    default: [
      "\u0642 \u0648 \u0639 \u0631 \u062A \u06D2 \u0621 \u0649 \u06C1 \u067E",
      "\u0627 \u0633 \u062F \u0641 \u06AF \u06BE \u062C \u06A9 \u0644 \u061B \u060C",
      "{shift} \u0632 \u0634 \u0686 \u0637 \u0628 \u0646 \u0645 {backspace}",
      "{numbers} {space} {ent}"
    ],
    shift: [
      
      "\uFE70 \uFE77 \uFE79 \u0691 \u0679 \uFE7A \uFEFB \uFE8B \u0629",
      "\u0622 \u0635 \u0688 \u060D \u063A \u062D \u0636 \u062E \u06D4 \u0703 \u05f4",
      "{shift} \u0630 \u0698 \u062B \u0638 \u06BA \u066b \u0640 \u061F {backspace}",
      "{numbers} {space} {ent}"
    ],
      numbers: ["\u0661 \u0662 \u0663", "\u0664 \u0665 \u0666", "\u0667 \u0668 \u0669", "{abc} \u0660 {backspace}"],
  },
  arabicmobile: {
    default: [
      "\u0636 \u0635 \u062B \u0642 \u0641 \u063A \u0639 \u0647 \u062E \u062D \u062C \u062F",
      "\u0634 \u0633 \u064A \u0628 \u0644 \u0627 \u062A \u0646 \u0645 \u0643 \u0637",
      "{shift} \u0626 \u0621 \u0624 \u0631 \u0644\u0627 \u0649 \u0629 \u0648 \u0632 \u0638 {backspace}",
      "{numbers} {space} {ent}"
    ],
    shift: [
      "\u064E \u064B \u064F \u064C \u0644\u0625 \u0625 \u2018 \u00F7 \u00D7 \u061B ",
      '\u0650 \u064D ] [ \u0644\u0623 \u0623 \u0640 \u060C',
      "{shift} \u0652 } { \u0644\u0622 \u0622 \u2019 \u061F {backspace}",
      "{numbers} {space} {ent}"
    ],
      numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
  },
  }
  
  export default lang;
  
   